import React, { useEffect, useState } from "react";
import jeopradybanner from "../../../main/assets/images/Images/Jeopardy Management - Images/jeopardy-management-banner.png";
import jp_banner_1 from "../../../main/assets/images/Images/Jeopardy Management - Images/jp_banner_1.png";
import costefficiency from "../../../main/assets/images/Icons/Jeopardy Management - Icons/cost-efficiency.svg";
import imporvedCustomer from "../../../main/assets/images/Icons/Jeopardy Management - Icons/improved-customer-satisfaction.png";
import reducedoperationaldelay from "../../../main/assets/images/Icons/Jeopardy Management - Icons/reduced-operational-delays.svg";
import reduceoperation from "main/assets/images/Icons/Jeopardy Management - Icons/reduce-operation.svg";
import costefficiency1 from "main/assets/images/Icons/Jeopardy Management - Icons/cost-efficiency1.svg";
import improvecustomer from "main/assets/images/Icons/Jeopardy Management - Icons/improve-customer.png";
import { Col } from "react-bootstrap";
import GraphDataOnLeft from "../../../main/components/componentsHelper/platformspage/GraphDataOnLeft";
import GraphDataOnRight from "../../../main/components/componentsHelper/platformspage/GraphDataOnRight";
import PlatformLearnMore from "main/components/componentsHelper/platformspage/PlatformLearnMore";
import { SectionCard } from "main/components";
import HeadingParagrap from "main/components/componentsHelper/platformspage/HeadingParagrap";
import { Button } from "main/components/ui-components/Button";
import { Link } from "react-router-dom";
import PlatformModulesBanner from "main/components/componentsHelper/platformspage/PlatformModulesBanner";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import jp_graph1 from "../../../main/assets/images/Images/Jeopardy Management - Images/jp_graph1.png";
import jp_graph2 from "../../../main/assets/images/Images/Jeopardy Management - Images/jp_graph2.png";
import jp_graph3 from "../../../main/assets/images/Images/Jeopardy Management - Images/jp_graph3.png";
import jp_graph4 from "../../../main/assets/images/Images/Jeopardy Management - Images/jp_graph4.png";
import jp_graph_1 from "../../../main/assets/images/Images/Jeopardy Management - Images/jp_graph_1.png";
import jp_graph_2 from "../../../main/assets/images/Images/Jeopardy Management - Images/jp_graph_2.png";
import jp_graph_3 from "../../../main/assets/images/Images/Jeopardy Management - Images/jp_graph_3.png";
import jp_graph_4 from "../../../main/assets/images/Images/Jeopardy Management - Images/jp_graph_4.png";
import SectionCardMobile from "main/components/componentsHelper/whtyantrapage/SectionCardMobile";
type Props = {};

const JeopradyManagement = (props: Props) => {
  interface CARDDATA {
    path: string;
    whiteIcon: string;
    title: string;
    textmsg: string;
  }
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [activetIndex, setActiveIndex] = useState(0);
  const goToSlide = (index: number) => {
    setActiveIndex(index);
  };
  const carddata: CARDDATA[] = [
    {
      path: reducedoperationaldelay,
      whiteIcon: reduceoperation,
      title: "Reduced Operational Delays",
      textmsg:
        "With instant decision-making support, reduce delays and improve service efficiency.",
    },
    {
      path: costefficiency,
      whiteIcon: costefficiency1,
      title: "Cost-Efficiency",
      textmsg:
        "Make resourceful decisions that not only enhance productivity but also save operational costs.",
    },
    {
      path: imporvedCustomer,
      whiteIcon: improvecustomer,
      title: "Improved Customer Satisfaction",
      textmsg:
        "By ensuring timely and effective field services, boost customer trust and satisfaction.",
    },
  ];

  return (
    <div>
      <PlatformModulesBanner
        backgroundImage={jeopradybanner}
        graphImage={jp_graph1}
        MobilebgImage={jp_banner_1}
        mobilepraphImage={jp_graph_1}
        descriptionClass="text-white-color fonts-400 font-20 mb-20 font-family-roboto"
        HeaderClassName="text-white-color fonts-300 font-40 mb-10 font-family-condensed plat-header"
        heading="Jeopardy Planning"
        description="Powering Field Services with Cognitive AI-driven 
           Recommendations"
        buttonGroup={
          <>
            <div className="d-block d-md-none">
              <Link to={"/contact-us"}>
                <Button
                  textclass="font-16 fonts-500 align-items-center text-center line-19 font-family-roboto-flex justify-content-center"
                  className="wx-90 hx-30 text-color-success radius-5 d-flex align-items-center text-align-center justify-content-center"
                  text="Book a Demo"
                />
              </Link>
            </div>
            <div className="d-none d-md-block">
              <Link to={"/contact-us"}>
                <Button
                  textclass="font-16 fonts-500 align-items-center text-center line-19 p-17 font-family-roboto-flex justify-content-center"
                  className="wx-147 hx-40 text-color-success radius-5 d-flex align-items-center text-align-center justify-content-center"
                  text="Book a Demo"
                />
              </Link>
            </div>
          </>
        }
      />
      <div>
        <HeadingParagrap
          heading="Jeopardy Planning"
          headingpara="A ground breaking solution that offers real-time triage, Jeopardy Work Orders, and Unscheduled Work Order management based on multiple dynamic factors and business rules."
          subheadingpara="Utilize the power of machine learning to ensure efficient workforce allocation, even with last-minute changes."
        />
        {/* website */}
        <div className="py-60 d-none d-md-block footer flex-gap-20 justify-content-center align-items-center">
          <div className="pb-60 d-flex text-white-color font-family-roboto font-30 flex-gap-20 fonts-800 line-35 justify-content-center align-items-center garph-heading">
            Key Capabilities
          </div>
          <div className="d-flex flex-column flex-gap-30 container justify-content-center align-items-center">
            <GraphDataOnLeft
              path={jp_graph2}
              headingClass="text-black-10"
              heading="Real Time Risk Dashboard "
              paragraph="Stay on top of Jeopardy, triage and unscheduled tasks with realtime unscheduled events and incidents."
            />
            <GraphDataOnRight
              path={jp_graph3}
              headingClass="text-black-10"
              heading="AI Driven Actionable Reports"
              paragraph="You can not only monitor the status of your unscheduled incidents , but also ensure that they get assigned to the nearest available technicians who has required skillsets to ensure SLA and CSAT. "
            />
            <GraphDataOnLeft
              path={jp_graph4}
              headingClass="text-black-10"
              heading="Granular visibility into daily operations"
              paragraph="Trace and take informative decisions with complete visibility throughout the region and generate alerts for business to take actions."
            />
          </div>
        </div>
        {/* Mobile View */}
        <div className="d-block d-md-none pb-30 footer flex-gap-20 justify-content-center align-items-center">
          <div className="d-flex text-white-color font-family-roboto font-30 flex-gap-20 fonts-800 line-35 pt-40 pb-10 justify-content-center align-items-center garph-heading">
            Key Capabilities
          </div>
          <div className="d-flex flex-column flex-gap-20 py-30 container graphcontainer justify-content-center align-items-center">
            <GraphDataOnLeft
              path={jp_graph_2}
              headingClass="text-black-10"
              heading="Real Time Risk Dashboard "
              paragraph="Stay on top of Jeopardy, triage and unscheduled tasks with realtime unscheduled events and incidents."
            />
            <GraphDataOnRight
              path={jp_graph_3}
              headingClass="text-black-10"
              heading="AI Driven Actionable Reports"
              paragraph="You can not only monitor the status of your unscheduled incidents , but also ensure that they get assigned to the nearest available technicians who has required skillsets to ensure SLA and CSAT. "
            />
            <GraphDataOnLeft
              path={jp_graph_4}
              headingClass="text-black-10"
              heading="Granular visibility into daily operations"
              paragraph="Trace and take informative decisions with complete visibility throughout the region and generate alerts for business to take actions."
            />
          </div>
        </div>
        {/* mobile */}
        <div className="d-block  d-md-none">
          <div className="container-fluid">
            <h2 className="dark-header font-30 font-family-roboto fonts-800 line-35 mt-4 d-flex justify-content-center align-items-center plat-header">
              Benefits
            </h2>
            <div className="row mx-1 mb-40 p-10">
              <Swiper
                slidesPerView={"auto"}
                spaceBetween={0}
                pagination={{
                  clickable: true,
                }}
                modules={[Pagination]}
                className="mySwiper customSwiper"
              >
                {carddata.map((val, index) => (
                  <SwiperSlide className="p-10">
                    <div className="col-md-12 col-sm-12 col-lg-12 p-10">
                      <Col key={index}>
                        <SectionCardMobile
                          classname="cards"
                          title={val.title}
                          icon={val.path}
                          whiteIcon={val.whiteIcon}
                          desc={val.textmsg}
                        />
                      </Col>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
        {/* website */}
        <div className="d-none d-md-block pt-60 pb-30">
          <div className="container">
            <h2 className="dark-header font-30 font-family-roboto fonts-800 line-35 mb-20 d-flex justify-content-center align-items-center plat-header">
              Benefits
            </h2>
            <div className="row mx-1 p-10">
              {carddata.map((item, index) => (
                <div className="col-md-6 col-sm-6 col-lg-4 p-10">
                  <div
                    className={`scard-container d-flex flex-column py-20 radius-10 justify-content-center align-items-center border border-1`}
                    key={index}
                  >
                    <div className="image-container">
                      <img
                        className="sfront-image mx-5 my-3 mt-4"
                        src={item?.path}
                        alt="background will be here"
                      />
                      <img
                        className="sback-image mx-5 mb-2"
                        src={item?.whiteIcon}
                        alt="background will be here"
                      />
                    </div>
                    <div className="card-body">
                      <p
                        className={`d-flex justify-content-center text-center card-title px-5 fonts-600 font-family-roboto font-26 line-30 pb-2`}
                        style={{ color: "#3D1187" }}
                      >
                        {item?.title}
                      </p>
                      <p
                        className="px-3 tcard-desc text-center text-white-color fonts-400 font-16 line-20 font-family-roboto"
                        style={{ color: "#3D1187" }}
                      >
                        {item?.textmsg}
                      </p>
                    </div>
                  </div>
                  <div className="d-block d-md-none text-center">
                    <button
                      key={index}
                      className={
                        index === activetIndex
                          ? "active p-1"
                          : "banner-slider p-1"
                      }
                      onClick={() => goToSlide(index)}
                    ></button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <PlatformLearnMore />
    </div>
  );
};

export default JeopradyManagement;
